const LF = 0x0A;

/**
 * Divide o fluxo ESC/POS sem deixar um avanço de linha no fim de um pacote.
 * Algumas impressoras Bluetooth de buffer pequeno descartam esse último byte
 * e acabam imprimindo o pacote seguinte sobre a linha anterior.
 */
export function dividirEscPosEmPacotes(dados: Uint8Array, tamanhoMaximo: number): Uint8Array[] {
    if (!Number.isInteger(tamanhoMaximo) || tamanhoMaximo <= 0) {
        throw new Error('O tamanho máximo do pacote deve ser um inteiro positivo.');
    }

    const pacotes: Uint8Array[] = [];
    let inicio = 0;

    while (inicio < dados.length) {
        let fim = Math.min(inicio + tamanhoMaximo, dados.length);

        if (fim < dados.length) {
            while (fim > inicio + 1 && dados[fim - 1] === LF) {
                fim--;
            }
        }

        pacotes.push(dados.slice(inicio, fim));
        inicio = fim;
    }

    return pacotes;
}

/**
 * Dá à impressora tempo proporcional para avançar e imprimir as linhas já
 * recebidas, evitando estouro do buffer em modelos Bluetooth mais lentos.
 */
export function calcularPausaEscPos(
    pacote: Uint8Array,
    pausaMinimaMs: number,
    pausaPorLinhaMs: number = 100
): number {
    const quantidadeLinhas = pacote.reduce(
        (total, byte) => total + (byte === LF ? 1 : 0),
        0
    );

    return Math.max(pausaMinimaMs, quantidadeLinhas * pausaPorLinhaMs);
}
